const path = require('path');
const envConfig = require('./env.config');

const config = Object.assign({},
    {
        dirs: {
            root: path.resolve(__dirname + '/../'),
            app: '/app'
        }
    },
    envConfig
);

// keep both for now
module.exports = exports['default'] = config;



// WEBPACK FOOTER //
// ./config/index.js